import { ResourcedTexts, Result, OfficeResult } from "../SearchFilterResultData";
import { OfficeResultCard } from "./OfficeResultCard";

type ResultsProps = {
  results: Result[];
  resourcedTexts: ResourcedTexts;
  sidebarIsActive?: boolean;
  loading?: boolean;
};

export function Results({ results, resourcedTexts, sidebarIsActive, loading }: ResultsProps) {
  const noResults = !results || results.length === 0;

  if (noResults) {
    return (
      <div className="results">
        <h3 className="large-title">{resourcedTexts.noResultsFound}</h3>
      </div>
    );
  }

  return (
    <div className="results">
      {results.map((item, index) => (
        <OfficeResultCard
          key={`${index}-${item.title}`}
          resourcedTexts={resourcedTexts}
          sidebarIsActive={sidebarIsActive}
          {...(item as OfficeResult)}
        />
      ))}
      {loading && <div className="results__overlay" />}
    </div>
  );
}
